<template>
  <font-awesome-icon
    icon="history"
    class="fa" />
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core'
import { faHistory } from '@fortawesome/free-solid-svg-icons'

library.add(faHistory)

export default {
  name: 'CoozzyPendingIcon'
}
</script>

<style lang="scss" scoped>
  .fa {
    color: $color-blue;
  }
</style>
